<ion-content class="ion-page brand-default" [fullscreen]="true">
  <div class="landing-page-container">
    <div class="signin-register-form-container">
      <div class="logo-features-pane">
        <div class="logo-container">
          <a href="/">
            <ion-img id="topmenu-logo" src="{{ companyLogoImagePath }}" alt="Quotify Logo">
            </ion-img>
          </a>
        </div>
        <div class="feature-list">
          <div class="feature">
            <ion-icon name="document-outline"></ion-icon>
            <div>
              <h3>Create Quotes Faster</h3>
              <p>Streamline your quoting process.</p>
            </div>
          </div>
          <div class="feature">
            <ion-icon name="people-outline"></ion-icon>
            <div>
              <h3>Manage Projects Efficiently</h3>
              <p>Keep everything organized and in one place.</p>
            </div>
          </div>
          <div class="feature">
            <ion-icon name="bar-chart-outline"></ion-icon>
            <div>
              <h3>Close More Business</h3>
              <p>Turn opportunities into results.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="signin-register-pane">
        <form [formGroup]="userLoginFormGroup" (ngSubmit)="loginUser()">
          <h1>Welcome Back</h1>
          <h2>Sign in to continue to your account</h2>
          <div class="form-fields">
            <ion-label for="Email" class="light-label">Email Address</ion-label>
            <ion-input #userNameInputField type="text" id="Email" ngDefaultControl class="rounded-input" formControlName="Email"
              (value)="loginRequest.Email" placeholder="you@company.com"></ion-input>
            <error-messages [control]="userLoginFormGroup.get('Email')" [fieldName]="'Email'"></error-messages>
          </div>
          <div class="form-fields">
            <ion-label for="Password" class="light-label">Password</ion-label>
            <div class="password-container">
              <ion-input #passwordInputField type="password" id="Password" ngDefaultControl class="rounded-input"
                formControlName="Password" (value)="loginRequest.Password" togglePassword placeholder="Enter your password">
              </ion-input>
            </div>
            <error-messages [control]="userLoginFormGroup.get('Password')" [fieldName]="'Password'"></error-messages>
            <ion-router-link id="ForgotPasswordLink" class="forgot-password" routerLink="/user/user-forgot-password">
              Forgot Password?</ion-router-link>
          </div>
          <div class="form-fields">
            <ion-button type="submit" strong="true" size="medium" fill="solid" class="">
              Sign In
              <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
            </ion-button>
          </div>
          <div class="switch-form-container">
            <div>OR</div>
            <ion-router-link id="RegisterLink" class="register-link" routerLink="/user/user-register">
              Don't have an account? Register</ion-router-link>
          </div>
          <div>
            <ion-label>{{ userMessage }}</ion-label>
          </div>
        </form>
      </div>
    </div>
  </div>
</ion-content>
